// extracted by mini-css-extract-plugin
export default {"table":"dT460FGiwLwVA19frbjT","read":"zKYyhCzjsty1TQ6a_SVY","unread":"lpo2K0qTIDWcswHCQcUa"};